var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnSolar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.95 56.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;stroke:#4b4a4a;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.7px}.cls-2{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.85 55.3H53.1M31.21 55.3h-8.47M19.23 49.25h-8.47M3.96 35.17h46.03M7.83 55.3V35.17M46.05 55.3V35.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m3.96 35.17 6.8-13.86h32.43l6.8 13.86M12.01 41.78h5.97v7.46h-5.97zM23.99 41.78h5.97V55.3h-5.97zM35.97 41.78h5.97v7.46h-5.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.19 49.25h-8.47"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.09,
    cy: 9.22,
    r: 2.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.09.85v3.07M36.18 2.45l1.8 2.48M33.14 6.63l2.92.95M33.14 11.8l2.92-.95M36.18 15.98l1.8-2.48M41.09 17.58v-3.07M46.01 15.98l-1.8-2.48M49.05 11.8l-2.92-.95M49.05 6.63l-2.92.95M46.01 2.45l-1.8 2.48M10.96 35.17l4.8-13.86M43.32 35.15l-5.8-13.85M26.98 35.17V21.31M18.85 35.15l2.49-13.84M34.78 35.14l-2.49-13.83M8.84 25.23h36.27M6.55 29.89h40.68"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSolar);
export default __webpack_public_path__ + "static/media/icn-solar.8682f98a0b9805243f5a92209124c350.svg";
export { ForwardRef as ReactComponent };